import { render, staticRenderFns } from "./ProStatsIcon.vue?vue&type=template&id=d1b711d4"
import script from "./ProStatsIcon.vue?vue&type=script&lang=js"
export * from "./ProStatsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports